<div class="panel" [class.luxury]="listingCategory === ListingCategory.LUXURY" [attr.aria-expanded]="shouldShowAccordion" role="tab" (click)="shouldShowAccordion = !shouldShowAccordion">
  <div class="panel-heading is-flex has-flex-align-center">
    <span [translate]="label" class="acc-label"></span>
    <ng-content select="[header]"></ng-content>
    <span class="expand-icon is-flex has-flex-content-end">
      <i class="material-icons" [class.rotate]="shouldShowAccordion">expand_more</i>
    </span>
  </div>
</div>
<div class="panel-collapse" [class.collapsed]="!shouldShowAccordion" [class.luxury]="listingCategory === ListingCategory.LUXURY" role="tabpanel">
  <div class="content has-padding-sides">
    <div *ngIf="textOnly" class="text-only">
      {{ text }}
    </div>
    <ng-content *ngIf="!textOnly"></ng-content>
  </div>
</div>
